import { AutocompleteArrayInput, TextInput } from "react-admin";
import { DateRange } from "../../../DateRange";

export const RewardFilters = [
  <DateRange alwaysOn />,
  <AutocompleteArrayInput
    variant="outlined"
    size="small"
    label="Delivery Mode"
    source="delivery_mode"
    choices={[
      { id: "VOUCHER-CODE", name: "VOUCHER-CODE" },
      { id: "COUPON-CODE", name: "COUPON-CODE" },
      { id: "AUTO-ORDER", name: "AUTO-ORDER" },
    ]}
    data-testid="search-delivery-mode"
  />,
  <AutocompleteArrayInput
    label="Service"
    variant="outlined"
    size="small"
    source="availability_by_service"
    choices={[
      { id: "G2", name: "G2" },
      { id: "M21", name: "M21" },
      { id: "GHK", name: "GHK" },
    ]}
    data-testid="search-service-availability"
  />,
  <TextInput
    source="item_name"
    label="Item Name HK"
    alwaysOn
    data-test-id="search-by-item-name"
  />,
];
